<template>
    <div id="if-wrapper">
        <div id="outer" v-if="showUntersuchungenOverview">
            <div id="title-row" class="m-3">
                <h4>Erfasste technische Untersuchungen zum Patienten
                </h4>
            </div>
            <div id="new-tu-button" class="px-4">
                <b-button variant="outline-primary" @click="startAddNewTU">Untersuchung hinzufügen
                    <b-icon-plus-circle/>
                </b-button>
            </div>
            <div id="table-row" class="m-4">
                <b-table show-empty striped bordered head-variant="light"
                         :fields="untersuchungenListFields"
                         :items="untersuchungenList">
                    <template #empty="">
                        {{ infoTextTableEmpty }}
                    </template>
                    <template #cell(type)="data">
                        {{ data.item.type }}
                    </template>
                    <template #cell(befund)="data">
                        {{ data.item.befund }}
                    </template>
                    <template #cell(date)="data">
                        <b-form-input type="date" style="width: 200px" v-model="data.item.date"
                                      v-on:input="dateChanged(data.item.date, data.index)" required
                                      :state="validDate(data.item.date)"
                                      aria-describedby="input-live-feedback" :min="patient.birthDate"
                                      :max="todayDate"></b-form-input>
                        <b-form-invalid-feedback id="input-live-feedback">
                            {{ infoTextNotValidDate }}
                        </b-form-invalid-feedback>
                    </template>
                    <template #cell(buttons)="data">
                        <b-button v-on:click="startEditTU(data.index)" class="mx-1" variant="outline-secondary">
                            <b-icon-pencil></b-icon-pencil>
                        </b-button>
                        <b-button v-on:click="showDeletionModal(data.index)" variant="outline-danger">
                            <b-icon-trash></b-icon-trash>
                        </b-button>
                    </template>
                </b-table>
            </div>
        </div>
        <div style="height: 100%" v-else>
            <t-u-anlegen-component @canceled="onTUAnlegenCanceled" @finished="onTUAnlegenFinished"
                                   :index-of-edited-t-u="indexOfEditedTU"/>
        </div>
        <DeletionModal :show="deletionModalDisplayed"
                       :subheader-message="modalMessage"
                       :header-message="'Technische Untersuchungserfassung wirklich abbrechen?'"
                       @close="closeDeletionModal"
                       @deleteConfirm="removeTU"/>
    </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import {isoDateFormat, localDateFormat} from "../../../js/util";
import TUAnlegenComponent from "./TUAnlegenComponent";
import infoTexte from "../../../js/clinical-algorithm/infoTexte/infoTexte";
import DeletionModal from "../../modal/DeletionModal";

export default {
    name: "TechnischeUntersuchungenRoot",
    components: {DeletionModal, TUAnlegenComponent},
    emits: {
        logout: null
    },
    data() {
        return {
            localDateFormat: localDateFormat,
            deletionModalDisplayed: false,
            modalMessage: '',
            indexToBeDeleted: null,
            showUntersuchungenOverview: true,
            indexOfEditedTU: undefined,
            untersuchungenListFields: [
                {
                    key: 'type',
                    label: 'Untersuchungsmodalität'
                },
                {
                    key: 'befund',
                    label: 'Befund'
                },
                {
                    key: 'date',
                    label: 'Datum',
                    thStyle: {width: '255px'}
                },
                {
                    key: 'buttons',
                    label: '',
                    thStyle: {width: '150px'}
                }
            ],
            infoTextNotValidDate: ""
        }
    },
    computed: {
        ...mapState('cdss/technischeUntersuchungen', {
            untersuchungenList: state => {
                let untersuchungenList = []
                if (state && state.untersuchungen) {
                    state.untersuchungen.forEach(untersuchung => {
                        untersuchungenList.push({
                            date: isoDateFormat(new Date(untersuchung.date)),
                            befund: untersuchung.value['FINDING_TEXT'],
                            type: untersuchung.value['MODALITY']
                        })
                    })
                }
                return untersuchungenList
            }
        }),
        ...mapGetters('cdss', [
            'patientId',
            'diagnosestellungReachable', 'patient'
        ]),
        infoTextTableEmpty: () => infoTexte.technischeUntersuchungenInstructionIfStillEmpty,
        todayDate() {
            return isoDateFormat(new Date())
        }
    },
    methods: {
        showDeletionModal(index) {
            this.indexToBeDeleted = index;
            let tuElement = this.untersuchungenList[this.indexToBeDeleted];
            let date = new Date(tuElement.date)
            this.modalMessage = tuElement.type + " Eintrag vom " + localDateFormat(date) + " wirklich löschen?";
            this.deletionModalDisplayed = true;
        },
        closeDeletionModal() {
            this.indexToBeDeleted = null;
            this.deletionModalDisplayed = false;
        },
        startAddNewAnfall() {
            this.$store.commit('cdss/setShowSavedDataFlag', false)
            this.showAnfaelleOverview = false;
        },
        removeTU() {
            this.$store.commit('cdss/technischeUntersuchungen/deleteTU', this.indexToBeDeleted)
            this.closeDeletionModal()
            this.updateDataInBackend()
        },
        dateChanged(date, index) {
            if (date !== "" && this.validDate(date) === null) {
                this.$store.commit('cdss/technischeUntersuchungen/changeDateOfTechnischeUntersuchung', {
                    date: new Date(date),
                    index: index
                })
                this.updateDataInBackend()
            }
        },
        startAddNewTU() {
            this.indexOfEditedTU = undefined
            this.startEditTU()
        },
        startEditTU(index) {
            this.indexOfEditedTU = index
            this.$store.commit('cdss/setShowSavedDataFlag', false)
            this.showUntersuchungenOverview = false;
            this.$store.commit('cdss/setShowUntersuchungenOverview', false)
        },
        onTUAnlegenCanceled() {
            this.backToOverview()
        },
        onTUAnlegenFinished(untersuchung) {
            console.log('onTUAnlegenFinished', untersuchung)
            if (this.indexOfEditedTU === undefined) {
                this.$store.commit('cdss/technischeUntersuchungen/pushUntersuchungToUntersuchungenList', untersuchung)
            } else {
                this.$store.commit('cdss/technischeUntersuchungen/changeUntersuchungByIndex', {
                    untersuchung: untersuchung,
                    index: this.indexOfEditedTU
                })
            }
            this.indexOfEditedTU = undefined
            this.backToOverview()
        },
        backToOverview() {
            this.$store.commit('cdss/setShowSavedDataFlag', true)
            this.indexOfEditedTU = undefined
            this.showUntersuchungenOverview = true;
            this.$store.commit('cdss/setShowUntersuchungenOverview', true)
        },
        validDate(date) {
            const pattern = /^\d{4}-\d{2}-\d{2}$/;
            if (!pattern.test(date)) {
                this.infoTextNotValidDate = infoTexte.notValidDate
                return false
            } else if (new Date(date) > new Date()) {
                this.infoTextNotValidDate = infoTexte.dateInTheFuture
                return false
            } else if (new Date(date) < new Date(this.patient.birthDate)) {
                this.infoTextNotValidDate = infoTexte.dateBeforeBirth
                return false
            } else
                return null
        }
    }
}
</script>

<style scoped>
#if-wrapper {
    height: 100%;
    background-color: white;
}

#outer {
    display: grid;
    grid-template-areas: "title" "button" "anfaelle-table";
    grid-template-columns: 1fr;
    grid-template-rows: 50px 20px 1fr;
    height: 100%;
}

#title-row {
    grid-area: title;
}

#table-row {
    grid-area: anfaelle-table;
}

#new-tu-button {
    grid-area: button;
    justify-self: right;
}
</style>
